import { render } from "./DocCenter.vue?vue&type=template&id=3ead718c&scoped=true"
import script from "./DocCenter.vue?vue&type=script&lang=js"
export * from "./DocCenter.vue?vue&type=script&lang=js"

import "./DocCenter.vue?vue&type=style&index=0&id=3ead718c&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ead718c"]])

export default __exports__